import * as React from 'react';
import styled from "styled-components";

interface TextContentBoxProps {
  number: string | number;
  title: string;
  children?: React.ReactNode | React.ReactNodeArray;
}

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  min-height: 215px;
  padding: 20px;
  background: #F6F9FF;
  border-radius: 20px;
  box-sizing: border-box;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
  margin-bottom: 12px;
`

const Number = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
  
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid #29292B;
`

const Content = styled.div`
  display: grid;
  gap: 10px;

  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #67686B;
`

/**
 * render landing page functional text content box
 * @constructor
 */
export default function TextContentBox(
  props: TextContentBoxProps
): React.ReactElement {
  return (
    <Container>
      <Number>{props.number}</Number>
      <Title>{props.title}</Title>
      <Content>
        {props.children}
      </Content>
    </Container>
  );
}
